'use client';

import type {PlayerRef} from '@remotion/player';
import type {RefObject} from 'react';
import type {DtoProjectType} from '@/shared/constants/dto';
import {GeneratedSourceFeed} from '@waka/compat/GeneratedSourceFeed';
import type {GeneratedSourceFilter} from '@waka/compat/generated-source-feed';

interface AiSourceGeneratedFeedProps {
  projectId: number;
  playerRef: RefObject<PlayerRef | null>;
  projectType: DtoProjectType;
  filter: GeneratedSourceFilter;
}

// The native document owns generated sources; company project IDs are not source identities.
export default function AiSourceGeneratedFeed({playerRef, filter}: AiSourceGeneratedFeedProps) {
  return <GeneratedSourceFeed playerRef={playerRef} filter={filter}/>;
}
